export const rejectInformationCollaboratorInitialState = {
	collaborators: undefined,
	loading: false,
	error: null,
	errorShow: false,
	getData: false,
};
